module.exports = __webpack_public_path__ + "img/iphone-map-SPAIN-en.c46e48d2.png";